function contractContactsAreDifferent(a, b) {
    for (const key in a) {
        if (a[key] !== b[key]) {
            return true;
        }
    }
    return false;
}
export default contractContactsAreDifferent;
